/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  Input,
  Space,
  Button,
  Checkbox,
  Modal,
  Drawer,
  Typography,
  Select,
  Divider,
  Upload,
  Image,
  //Spin,
  Switch,
  Table,
  message,
  Tag,
  Popover,
  // Button,
} from "antd";
import "../index.css";
import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import api from "../../../helpers";
import toast from "react-hot-toast";
import SortableTree from "@nosferatu500/react-sortable-tree";
import "@nosferatu500/react-sortable-tree/style.css";
import { FaRegEdit } from "react-icons/fa";
import {
  loadAccessList,
  loadMenuList,
  loadInfoList,
} from "../../../store/purchase-orders/actions";
import SimpleReactValidator from "simple-react-validator";
import Resizer from "react-image-file-resizer";

const MenuDetails = (props) => {
  const dispatch = useDispatch();

  const media = useMedia();
  // const userValues = localStorage.getItem("authData");

  // const userNameDetails = JSON.parse(userValues);

  // const organizationId =
  //   !isEmpty(userNameDetails) &&
  //   userNameDetails.user &&
  //   userNameDetails.user.organizations.length > 0
  //     ? userNameDetails.user.organizations[0].organizationId
  //     : "";
  // const userId =
  //   !isEmpty(userNameDetails) && userNameDetails.user && userNameDetails.user
  //     ? userNameDetails.user._id
  //     : "";

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);

    dispatch(loadMenuList());
    dispatch(loadAccessList());
    dispatch(loadInfoList());
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const {
    menu_list = [],
    access_list = [],
    info_List = [],
  } = useSelector((state) => state.PurchaseOrders);

  console.log("Info List", info_List);
  // const [infoDetails, setInfoDetails] = useState(info_List)
  //initial state values
  const [treeData, setTreeData] = useState([]);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

//  const [infoDetails, setInfoDetails] = useState([]);

  //Validations
  const simpleValidator = React.useRef(new SimpleReactValidator());
  const menuValidator = React.useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();
  const [editModal, setEditModal] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [removeBtnDisabled, setRemoveBtnDisabled] = useState(false);
//  const [menuSubmit, setMenuSubmit] = React.useState(false);
  const [menuDetails, setMenuDetails] = React.useState([]);
//  const [removeMenuModal, setRemoveMenuModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  //const [isOn, setIsOn] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  // const [menuHeaderReference, setMenuHeaderReference] = React.useState([]);
  // const [menuSubHeaderReference, setMenuSubHeaderReference] = React.useState(
  //   []
  // );
  // const [accessDetails, setAccessDetails] = React.useState([]);

  const [menuType, setMenuType] = useState([]);
  const [subHeader, setSubHeader] = useState([]);
  const [menuName, setMenuName] = useState("");
  const [menuKey, setMenuKey] = useState("");
  const [menuAccess, setMenuAccess] = useState([]);
  const [menuMode, setMenuMode] = useState([]);
  // const [isEdit, setIsEdit] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [newLabel, setNewLabel] = useState("");
  const [removeId, setRemoveId] = React.useState("");
  const [menuData, setMenuData] = React.useState({
    menuName: "",
    _id: "",
    menukey: "",
    menuReferenceId: [],
    isNew: false,
    labelName: "",
    access: [],
    sequence: 1,
  });

  console.log(menuAccess, "menuAccess");

  //isEnable
  const [isEnable, setIsEnable] = useState(false);

  //data split

  const accessOptions =
    access_list && access_list.length > 0
      ? access_list
          .filter((opt) => !menuAccess.find((item) => item.value === opt._id))
          .map((data) => {
            return {
              label: data.accessName,
              value: data._id,
            };
          })
      : [];

  const menuHeader =
    menuDetails && menuDetails.length > 0
      ? menuDetails.filter((r) => r.menuType == "Menu Header") &&
        menuDetails.filter((r) => r.menuType == "Menu Header")
      : menu_list && menu_list.length > 0
      ? menu_list.filter((r) => r.menuType == "Menu Header") &&
        menu_list.filter((r) => r.menuType == "Menu Header")
      : [];
  // const menuSubHeader =
  //   menuDetails && menuDetails.length > 0
  //     ? menuDetails.filter((r) => r.menuType == "SubHeader") &&
  //       menuDetails.filter((r) => r.menuType == "SubHeader").menu
  //     : menu_list && menu_list.length > 0
  //     ? menu_list.filter((r) => r.menuType == "SubHeader") &&
  //       menu_list.filter((r) => r.menuType == "SubHeader").menu
  //     : [];
  console.log(menuDetails, "menuDetails");
  //Menu header dropdown
  // const menuHeaderOptions =
  //   menuHeader && menuHeader.length > 0
  //     ? menuHeader.map((data) => {
  //         return {
  //           label: data.menuName,
  //           value: data._id,
  //         };
  //       })
  //     : [];

  const accessDetailsArray =
    menuAccess && menuAccess.length > 0
      ? menuAccess.map((data) => data.value)
      : [];

  //Menu header dropdown
  // const menuSubHeaderOptions =
  //   menuSubHeader && menuSubHeader.length > 0
  //     ? menuSubHeader.map((data) => {
  //         const subMenuName =
  //           menuHeaderOptions && menuHeaderOptions.length > 0
  //             ? menuHeaderOptions.find(
  //                 (menuHead) => menuHead.value == data.menuReferenceId
  //               )
  //             : "";
  //         // console.log(subMenuName, 'subMenuName');
  //         return {
  //           label: data.menuName,
  //           value: data._id,
  //           menuType: data.menuType,
  //           menuReferenceId: data.menuReferenceId,
  //           menuReferenceName: !isEmpty(subMenuName) ? subMenuName.label : "",
  //         };
  //       })
  //     : [];

  // const handleInfoClick = (title) => {
  //   setModalTitle(`${title}`);
  //   setIsModalOpen(true);
  // };
  // const handleInfoClick = (title, record) => {
  //   setModalTitle(`${title}`);
  //   setCurrentMenuId(record._id); // Store the menu ID
  //   setIsModalOpen(true);
  // };

  //title formatter
  const titleFormatter = (title, record) => {
    console.log(record, "record from tree");
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "content-between",
          // height: '80px',
          marginBottom: "25px",
        }}
      >
        <div className="mt-5">
          <h4
            style={{
              textTransform: "capitalize",
              marginBottom: "5px",
              // marginTop: "5px",
              fontSize: "14px",
            }}
          >
            {title}
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "-2px",
            }}
          >
            <p
              style={{
                paddingRight: "8px",
                paddingLeft: "8px",
                borderRadius: "12px",
                backgroundColor:
                  record.status &&
                  record.status.length > 0 &&
                  record.status[0].statusCode === 1
                    ? "#34bf8cdb"
                    : "#e74c3c",
                border: "none",
                color: "white",
                marginLeft: "5px",
                // fontFamily: "Poppins",
              }}
              pill
              className="font-label text-[11px] font-medium"
            >
              {record.status &&
              record.status.length > 0 &&
              record.status[0].statusCode === 1
                ? "Active"
                : "Inactive"}
            </p>
            <p
              style={{
                paddingRight: "8px",
                paddingLeft: "8px",
                borderRadius: "12px",
                backgroundColor:
                  record.menuMode !== undefined && record.menuMode === "Menu"
                    ? "#3498db"
                    : "#e74c3c",
                border: "none",
                color: "white",
                marginLeft: "5px",
                // fontFamily: "Poppins",
              }}
              pill
              className="font-label text-[11px] font-medium"
            >
              {record.menuMode === "Menu" ? "Menu" : "Page"}
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            marginLeft: "70px",
            height: "30px",
            marginTop: "28px",
          }}
        >
          <div
            style={{
              display: "flex",
              // justifyContent: 'center',
              background: "#34c38f",
              // alignItems: 'center',
              borderRadius: "4px",
              padding: "6px",
              color: "white",
              border: "none",
              cursor: "pointer",
              // marginBottom: '10px',
            }}
            onClick={() => editMenu(record)}
          >
            <FaRegEdit
              style={{
                width: "16px",
                height: "16px",
              }}
              // {...props}
              // record={record}
            />{" "}
          </div>
          <div
            style={{
              display: "flex",
              background: "#f46a6a",
              // justifyContent: 'center',
              borderRadius: "4px",
              border: "none",
              // alignItems: 'center',
              padding: "6px",
              marginLeft: "10px",
              color: "white",
              // marginRight: '10px',
              cursor: "pointer",
            }}
            onClick={() => {
              setConfirmationModal(true);
              setRemoveId(record);
            }}
          >
            <DeleteOutlined
              style={{
                width: "16px",
                height: "16px",
              }}
              // {...props}
              // record={record}
            />
          </div>
          <div
            style={{
              display: "flex",
              background: "#007AFF",
              borderRadius: "4px",
              border: "none",
              padding: "6px",
              marginLeft: "10px",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => handleInfoClick(record.menuName, record, info_List)}
          >
            <InfoCircleOutlined
              style={{
                width: "16px",
                height: "16px",
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  //Table Coulmns

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <div style={{ display: "flex", height: "30px" }}>
          <div
            style={{
              display: "flex",
              background: "#34c38f",
              borderRadius: "4px",
              padding: "6px",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => handleEdit(record)}
          >
            <FaRegEdit style={{ width: "16px", height: "16px" }} />
          </div>
          <div
            style={{
              display: "flex",
              background: "#f46a6a",
              borderRadius: "4px",
              border: "none",
              padding: "6px",
              marginLeft: "10px",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => {
              setDeleteId(record._id);
              setDeleteConfirmationModal(true);
            }}
          >
            <DeleteOutlined style={{ width: "16px", height: "16px" }} />
          </div>
        </div>
      ),
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (color) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              style={{
                backgroundColor: color,
                width: "20px",
                height: "20px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            <span>{color}</span>
          </div>
        );
      },
    },
    // {
    //   title: "Icon",
    //   dataIndex: "icon",
    //   key: "icon",
    //   render: (icon) => (icon ? <Image src={icon} width={24} /> : "---"),
    // },
    {
      title: "Icon",
      dataIndex: "icon",
      key: "icon",
      render: (icon, record) => {
        if (!icon || icon === "--" || icon === "---") {
          return (
            <Button
              type="text"
              disabled
              style={{ color: "#bfbfbf", cursor: "not-allowed" }}
            >
              View
            </Button>
          );
        }

        return (
          <Popover
            content={<Image src={icon} width={100} preview={false} />}
            trigger="hover"
          >
            <Button
              type="link"
              onClick={() => window.open(icon, "_blank")}
              style={{ padding: 0 }}
            >
              <Image
                src={icon}
                width={24}
                preview={false}
                alt={`icon-${record.menuName || "icon"}`}
              />
            </Button>
          </Popover>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isenable",
      key: "isenable",
      render: (isenable) => (
        <Tag color={isenable ? "green" : "red"}>{isenable ? "ON" : "OFF"}</Tag>
      ),
    },
  ];

  const recordsTree =
    menuHeader && menuHeader.length > 0
      ? menuHeader.reduce((a, el) => {
          // console.log(a, "menu tree");
          console.log(el, "menu el tree");
          const subMenu = (el && el.subMenus.length > 0 && el.subMenus) || [];

          console.log(subMenu, "subMenu");
          if (subMenu && subMenu.length > 0) {
            const children = subMenu.reduce((arr, item) => {
              // const subMenuItem =
              //   (menuItem &&
              //     menuItem.length > 0 &&
              //     menuItem.filter((m) =>
              //       !isEmpty(m.menuReferenceId)
              //         ? m.menuReferenceId.toString() === item._id.toString()
              //         : item._id.toString()
              //     )) ||
              //   // m.menuReferenceId.toString() === item._id.toString())) ||
              //   [];
              // if (subMenuItem && subMenuItem.length > 0) {
              //   const childrenItems = menuItem
              //     // .filter((m) => item._id.toString())
              //     .filter((m) =>
              //       !isEmpty(m.menuReferenceId)
              //         ? m.menuReferenceId.toString() === item._id.toString()
              //         : item._id.toString()
              //     )
              //     .map((k) =>
              //       Object.assign({}, k, { title: titleFormatter(k.menuName, k) })
              //     );
              //   arr.push(
              //     Object.assign({}, item, {
              //       title: titleFormatter(item.menuName, item),
              //       children: childrenItems,
              //       expanded: false,
              //     })
              //   );
              // } else {
              arr.push(
                Object.assign({}, item, {
                  title: titleFormatter(item.menuName, item),
                  expanded: false,
                })
              );
              // }

              return arr;
            }, []);
            a.push(
              Object.assign({}, el, {
                title: titleFormatter(el.menuName, el),
                children,
                expanded: false,
              })
            );
          } else {
            a.push(
              Object.assign({}, el, {
                title: titleFormatter(el.menuName, el),
                expanded: false,
              })
            );
            console.log(a, "menu tree");
          }
          return a;
        }, [])
      : [];

  const recordsTreeArray =
    !isEmpty(recordsTree) && recordsTree && recordsTree.length > 0
      ? recordsTree
      : [];

  // console.log(recordsTree, "recordsTree");
  // console.log(recordsTreeArray, "recordsTreeArray");
  // console.log(treeData, 'treeData');
  const [recordTreeLoad, setRecordTreeLoad] = useState(false);
  const [pageLoad, setPageLoad] = useState(false);

  useEffect(() => {
    if (menuDetails && menuDetails.length > 0) {
      setTreeData(recordsTreeArray);
      setPageLoad(!pageLoad);
    } else if (recordsTreeArray && recordsTreeArray.length > 0) {
      setTreeData(recordsTreeArray);
      setPageLoad(!pageLoad);
    } else if (
      recordsTreeArray &&
      (recordsTreeArray.length > 0) & !recordTreeLoad
    ) {
      setTreeData(recordsTreeArray);
      setRecordTreeLoad(true);
      setPageLoad(!pageLoad);
    }
  }, [menu_list, menuDetails]);

 // const [draggedRefId, setDraggedRefId] = React.useState("");
  // const [draggedMenuSeq, setDraggedMenuSeq] = React.useState("");
  // const [draggedMenuId, setDraggedMenuId] = React.useState([]);

  //console.log(treeData, "treeData");
//  console.log(draggedRefId, "draggedRefId");

  // const handleTreeData = (newTreeData) => {
  //   console.log("Updated Tree Data:", newTreeData);

  //   setTreeData(newTreeData);
  // };

  // useEffect(() => {
  //   if (treeData && draggedRefId) {
  //     // Find the dragged item's parent (draggedMenuArray)
  //     const draggedMenuArray = treeData.filter(
  //       (data) => data._id == draggedRefId
  //     );
  //     console.log(draggedMenuArray, "DraggedMenuArray");

  //     if (draggedMenuArray.length > 0 && draggedMenuArray[0].children) {
  //       const children = [...draggedMenuArray[0].children]; // Clone to avoid mutation
  //       console.log(children, "Dragged Parent Children");
  //       console.log(draggedMenuId, "DraggedMenuId");

  //       // Find the dragged item inside children
  //       const draggedIndex = children.findIndex(
  //         (child) => child._id == draggedMenuId
  //       );
  //       console.log(draggedIndex, "DraggedIndex");

  //       let swapIndex = null; // Index of the item to swap with
  //       let menuSequence = null;

  //       if (draggedIndex !== -1) {
  //         if (draggedIndex < children.length - 1) {
  //           // **Case 1: There's a next child** (Swap with next child)
  //           swapIndex = draggedIndex + 1;
  //         } else if (draggedIndex > 0) {
  //           // **Case 2: Last child** (Swap with previous child)
  //           swapIndex = draggedIndex - 1;
  //         }

  //         if (swapIndex !== null) {
  //           const swapChild = children[swapIndex];

  //           if (swapChild) {
  //             const restChildrens = children
  //               .filter(
  //                 (data) =>
  //                   data._id !== draggedMenuId && data._id !== swapChild._id
  //               )
  //               .map((data) => ({
  //                 _id: data._id,
  //                 sequence: data.sequence,
  //               }));

  //             menuSequence = {
  //               menuSequanceList: [
  //                 {
  //                   _id: draggedMenuId,
  //                   sequence: swapChild.sequence, // Assign swap child's sequence to dragged item
  //                 },
  //                 {
  //                   _id: swapChild._id,
  //                   sequence: children[draggedIndex].sequence, // Assign dragged item's sequence to swap child
  //                 },
  //                 ...restChildrens,
  //               ],
  //             };

  //             console.log(restChildrens, "restChildrens ");
  //             console.log(menuSequence, "Updated Menu Sequence");

  //             setPageLoad(!pageLoad);

  //             // Reset states
  //             setDraggedMenuId("");
  //             setDraggedMenuSeq([]);
  //             setDraggedRefId("");
  //           }
  //         } else {
  //           console.log("No valid swap found.");
  //         }
  //       }
  //     }
  //   }
  // }, [draggedRefId, treeData]);

  console.log(accessOptions, "accessOptions");
  console.log(treeData, "treeData");
  console.log(menu_list, "menu_list");

  const onClose = () => setOpen(false);

  //Add designations
  const addMenuDetails = (e) => {
    e.preventDefault();
    if (simpleValidator.current.allValid()) {
      // toast.success('Records Added Successfully');
      if (menuType.value == "menuHeader") {
        setButtonLoader(true);
        const menuList = {
          menuName: menuName,
          menuPath: menuKey,
          menuType: menuType.value,
          // menuReferenceId: menuReference.value,
          menuAccess: accessDetailsArray,
          isNew: menuData.isNew,
          labelName: menuData.labelName,
          menuMode: menuMode.value,
          // sequence: menuData.sequence,
          // userId: userId,
        };
        api
          .post("/addMenu", menuList)
          .then((res) => {
            // setTimeout(() => {
            api.post("/getMenu", { status: "both" }).then((res) => {
              console.log(res.data, "data menuDetails");
              setMenuDetails(res.data.data);
              return res.data;
            });
            dispatch(loadMenuList());
            setOpen(false);
            toast.success("Records Added Successfully");
            setButtonLoader(false);
            setRecordTreeLoad(false);
       //     setMenuSubmit(true);
            // }, 1000);
            return res.data;
          })
          .catch((error) => {
            setOpen(false);
            setButtonLoader(false);
            const errorMsg =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message;
            console.log(errorMsg, "errorMsg");
            toast.error(errorMsg || "There is an issue while adding the menu");

            return Promise.reject(error);
          });
        // dispatch(addMenuList(menuList));
      } else {
        setButtonLoader(true);
        const menuList = {
          menuName: menuName,
          menuPath: menuKey,
          menuType: menuType.value,
          // menuReferenceId: menuReference.value,
          menuAccess: accessDetailsArray,
          isNew: menuData.isNew,
          headerMenu: subHeader && subHeader.value,
          labelName: menuData.labelName,
          menuMode: menuMode.value,
          // sequence: menuData.sequence,
        };
        api
          .post("/masters/addmenu", menuList)
          .then((res) => {
            setTimeout(() => {
              setOpen(false);
              api.post("/masters/getmenu").then((res) => {
                console.log(res.data, "data menuDetails");
                setMenuDetails(res.data.data);
                return res.data;
              });
              dispatch(loadMenuList());
              toast.success("Records Added Successfully");
              setButtonLoader(false);
              setRecordTreeLoad(false);
            //  setMenuSubmit(true);
            }, 1000);
            return res.data;
          })
          .catch((error) => {
            setOpen(false);
            setButtonLoader(false);
            const errorMsg =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message;
            console.log(errorMsg, "errorMsg");
            toast.error(errorMsg || "There is an issue while adding the menu");
            Promise.reject(error);
          });
        // console.log(menuList, 'menuList');
      }
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
    }
  };

  const editMenu = (data) => {
    console.log(data, "data");
    setMenuData({
      menuName: data?.menuName,
      labelName: data?.labelName,
      sequence: data?.sequence,
      menukey: data?.menukey,
      isNew: data?.isNew,
      _id: data?._id,
    });
    setMenuName(data?.menuName);
    setNewLabel(data?.labelName);
    setMenuKey(data?.menuPath);
    setIsNew(data?.isNew);
    setMenuMode(
      data.menuMode === "Page"
        ? { label: "Page", value: "Page" }
        : { label: "Menu", value: "Menu" }
    );
    setMenuType(
      data.menuType === "Menu Sub Header"
        ? { label: "Menu Sub Header", value: "Menu Sub Header" }
        : { label: "Menu Header", value: "Menu Header" }
    );
    setSubHeader({
      label: data.headerMenuName,
      value: data.headerMenu,
    });

    const accessArray =
      data.menuAccess && data.menuAccess.length > 0
        ? data.menuAccess.map((id) => ({
            value: id.accessId ? id.accessId : "",
            label: id.accessName ? id.accessName : "",
          }))
        : [];

    setMenuAccess(accessArray);

    // const menuSubHeadersArray =
    //   data.menuType == "menuSubHeader"
    //     ? menuHeaderOptions.find(
    //         (headerData) => headerData.value == data.menuReferenceId
    //       )
    //     : [];

    // const menuSubHeaders = menuSubHeadersArray
    //   ? { label: menuSubHeadersArray?.label, value: menuSubHeadersArray?.value }
    //   : {};

    setEditModal(true);
    setOpen(true);
  };

  //update designations
  const updateMenuDetails = () => {
    if (simpleValidator.current.allValid()) {
      setButtonLoader(true);
      if (menuType.value == "menuHeader") {
        const menuList = {
          menuId: menuData._id,
          menuName: menuName,
          menuPath: menuKey,
          menuType: menuType.value,
          // menuReferenceId: menuReference.value,
          menuAccess: accessDetailsArray,
          isNew: menuData.isNew,
          labelName: menuData.labelName,
          menuMode: menuMode.value,
        };
        api
          .post("/masters/updatemenu", menuList)
          .then((res) => {
          //  setMenuSubmit(true);
            setTimeout(() => {
              setRecordTreeLoad(false);
              api.post("/masters/getmenu").then((res) => {
                console.log(res.data, "data menuDetails");
                setMenuDetails(res.data.data);
                return res.data;
              });
              dispatch(loadMenuList());
              setButtonLoader(false);
              setOpen(false);
              setEditModal(false);
              toast.success("Records Updated Successfully");
            }, 1000);

            return res.data;
          })
          .catch((error) => {
            setButtonLoader(false);
            setOpen(false);
            setEditModal(false);
            const errorMsg =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message &&
              error.response.data.message.message;
            console.log(error, "error");
            toast.error(
              errorMsg || "There is an issue while updating the menu"
            );
            return Promise.reject(error);
          });
      } else {
        setButtonLoader(true);
        const menuList = {
          menuId: menuData._id,
          menuName: menuName,
          menuPath: menuKey,
          menuType: menuType.value,
          // menuReferenceId: menuReference.value,
          menuAccess: accessDetailsArray,
          isNew: menuData.isNew,
          headerMenu: subHeader && subHeader.value,
          labelName: menuData.labelName,
          menuMode: menuMode.value,
          // sequence: menuData.sequence,
        };
        api
          .post("/masters/updatemenu", menuList)
          .then((res) => {
         //   setMenuSubmit(true);
            setRecordTreeLoad(false);
            api.post("/masters/getmenu", { status: "both" }).then((res) => {
              console.log(res.data, "data menuDetails");
              setMenuDetails(res.data.data);
              return res.data;
            });
            dispatch(loadMenuList());
            setButtonLoader(false);
            setOpen(false);
            setEditModal(false);
            toast.success("Records Updated Successfully");
            return res.data;
          })
          .catch((error) => {
            setButtonLoader(false);
            setOpen(false);
            setEditModal(false);
            const errorMsg =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message &&
              error.response.data.message.message;
            console.log(error, "error");
            toast.error(
              errorMsg || "There is an issue while updating the menu"
            );
            return Promise.reject(error);
          });
        console.log(menuList, "menuList");
      }
      // toast.success('Records Added Successfully');
      // dispatch(updateMenuList(menuList));

      // console.log(menuList, 'menuList');
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
    }
  };

  //Remove data
  const removeMenuDetails = () => {
    setButtonLoader(true);
    setRemoveBtnDisabled(true);
    setTimeout(() => {
      setRemoveBtnDisabled(false);
    }, 1500);
    const menuList = {
      menuId: removeId._id,
    };
    api
      .post("/masters/deletemenu", menuList)
      .then((res) => {
        api.post("/masters/getmenu").then((res) => {
          setMenuDetails(res.data.data);
          return res.data;
        });
        dispatch(loadMenuList());
        setButtonLoader(false);
        setConfirmationModal(false);
        toast.error("Records Deleted Successfully");
        return res.data;
      })
      .catch((error) => {
        toast.error("There is an error while delete the menu");
        setButtonLoader(false);
   //     setRemoveMenuModal(false);
      });
    setPageLoad(!pageLoad);
  };

  //update information

  const [currentMenuId, setCurrentMenuId] = useState("");

  const [filteredTableData, setFilteredTableData] = useState([]);
  const [menuOpen, setMenuOpen] = useState("");

  // useEffect(() => {
  //   console.log("info_List updated", info_List);
  //   if (info_List.length > 0) {
  //     setInfoDetails(info_List); // keep a local copy when redux updates
  //   }
  // }, [info_List]);

  const tableData = !isEmpty(filteredTableData)
    ? filteredTableData
        .filter((item) => item)
        .map((data) => ({
          color: data?.updatedLabelNameColorCode || "--",
          label: data?.updatedLabelName || "--",
          // status: data?.isenable || false,
          icon: data?.icon || null,
          _id: data?._id || "",
          menuName: data?.menuName || "",
          isenable: data?.isenable || false,
        }))
    : [];

  console.log("Filtered table data", filteredTableData);
  console.log("Menu Open", menuOpen);

  useEffect(() => {
    if (info_List.length > 0) {
      // setInfoDetails(info_List); 
      if (menuOpen?.trim()) {
        const filteredData = info_List.filter(
          (item) =>
            item.menuName?.trim().toLowerCase() ===
            menuOpen?.trim().toLowerCase()
        );

        const isAllEmpty = filteredData.every((item) => {
          const hasLabel = !item.updatedLabelName?.trim();
          const hasColor = !item.updatedLabelNameColorCode?.trim();
          const hasIcon = !item.icon?.trim();
          const isDisabled = item.isenable === false;
          return hasLabel && hasColor && hasIcon && isDisabled;
        });

        const result = isAllEmpty ? [] : filteredData;
        setFilteredTableData(result);
      }
    }
  }, [info_List, menuOpen]);

  // const filterDataValue = () => {
  //   const currentInfoList = info_List || [];
  //   const filteredData = currentInfoList.filter(
  //     (item) =>
  //       item.menuName?.trim().toLowerCase() === menuOpen?.trim().toLowerCase()
  //   );

  //   const result = filteredData.every((item) => {
  //     const hasLabel = item.updatedLabelName?.trim() === "";
  //     const hasColor = item.updatedLabelNameColorCode?.trim() === "";
  //     const hasIcon = item.icon?.trim() === "";
  //     const isEnabled = item.isenable === false;
  //     return hasLabel && hasColor && hasIcon && isEnabled;
  //   })
  //     ? [] // all true
  //     : filteredData; // otherwise return filtered list

  //   // If filterNoData is empty, fall back to showing matchingMenuItems
  //   setFilteredTableData(result);
  // };
  const handleInfoClick = (title, record) => {
    setModalTitle(title);
    setCurrentMenuId(record._id);
    setMenuOpen(record.menuName); 
    setIsModalOpen(true);
  };


  //  useEffect(()=>{
  //   setInfoDetails(info_List)
  //  },[info_List])

  const handleEdit = (record) => {
    setCurrentMenuId(record._id);
    setLabel(record.label || "");
    setColor(record.color || "");
    setIconPreview(record.icon || "");
    // setIsEnable(record.isenable === false);
    setIsEnable(record.isenable);
    setIsEditMode(true);
    setIsModalOpen(true);
  };
  

  //window height/width

  const handleSubmit = () => {
    if (menuValidator.current.allValid()) {
      setDisabled(true);

      const payload = {
        menuId: currentMenuId,
        updatedLabelName: label,
        updatedLabelNameColorCode: color,
        icon: iconPreview || "",
        isenable: isEnable,
      };

      api
        .post("/masters/updatelabelname", payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            // Dispatch to update Redux store
            dispatch(loadInfoList());
            // filterDataValue();

            toast.success(
              isEditMode ? "Updated successfully" : "Submitted successfully"
            );

            resetFields();
            // setIsModalOpen(false);
          }
        })
        .catch((error) => {
          // Error handling
        })
        .finally(() => setDisabled(false));
    } else {
      menuValidator.current.showMessages();
      forceUpdate(1);
      setIsModalOpen(true);
    }
  };
  

  //delete funtionality

  const handleDelete = () => {
    setButtonLoader(true);
    const menuList = { menuId: deleteId };

    api
      .post("/masters/clearvalues", menuList)
      .then((res) => {
        // Update Redux store
        dispatch(loadInfoList());
        // filterDataValue();

        setDeleteConfirmationModal(false);
        setIsEditMode(false); // Reset edit mode
        toast.success("Deleted successfully");
      })
      .catch((error) => {
        // Error handling
      })
      .finally(() => setButtonLoader(false));
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [label, setLabel] = useState("");
  const [color, setColor] = useState("");
  const [iconPreview, setIconPreview] = useState(null);
//  const [iconFile, setIconFile] = useState(null);

  // const resizeImage = (file) =>
  //   new Promise((resolve) => {
  //     Resizer.imageFileResizer(
  //       file,
  //       24, // Width
  //       24, // Height
  //       "PNG", // Format
  //       100, // Quality
  //       0, // Rotation
  //       (uri) => {
  //         resolve(uri);
  //       },
  //       "base64" // Output type
  //     );
  //   });
  const resizeImage = (file) =>
    new Promise((resolve) => {
      const fileType = file.type.split("/")[1].toUpperCase(); // Get 'jpeg', 'png', etc.

      const supportedFormats = ["JPEG", "PNG", "WEBP"];
      const format = supportedFormats.includes(fileType) ? fileType : "JPEG";

      Resizer.imageFileResizer(
        file,
        24, // Width
        24, // Height
        format, // Dynamically set format
        100, // Quality
        0, // Rotation
        (uri) => {
          resolve(uri);
        },
        "base64" // Output type
      );
    });

  const handleUpload = async (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return false;
    }

    try {
      const resizedImage = await resizeImage(file);
     // setIconFile(file);
      setIconPreview(resizedImage);
    } catch (err) {
      message.error("Image processing failed");
      console.error(err);
    }
    return false; // Prevent default upload
  };

  const resetFields = () => {
    setLabel("");
    setColor("");
    setIconPreview(null);
   // setIconFile(null);
    setIsEnable(false);

    // Clear validation messages
    if (menuValidator.current) {
      menuValidator.current.hideMessages();
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Menu | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Menu
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="w-[100%] mt-2">
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 && windowDimensions.height < 830
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && windowDimensions.height < 1000
              ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] h-[70vh] rounded-md"
          }
        >
          <Row className="flex flex-col bg-[#ffffff]">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3 pr-5">
              <Row className="flex justify-end">
                <Col
                  md={4}
                  lg={5}
                  xl={4}
                  xxl={4}
                  sm={24}
                  xs={24}
                  className="mt-1 lg:mt-0 md:mt-0"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        minWidth:
                          media === "xxl"
                            ? "185%"
                            : media == "sm" || media == "xs"
                            ? "245%"
                            : "125%",
                        paddingRight: media == "md" ? "20px" : "20px",
                        height: "35px",
                        marginLeft:
                          media == "sm" || media == "xs" ? "10px" : "",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        sm={14}
                        xs={14}
                        className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0"
                      >
                        <div
                          onClick={() => {
                            setOpen(true);
                            setEditModal(false);
                            setMenuType([]);
                            setSubHeader([]);
                            setMenuMode([]);
                            setMenuAccess([]);
                            setIsNew(false);
                            setNewLabel("");
                            setMenuKey("");
                            setMenuName("");
                          }}
                          className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]"
                        >
                          <PlusOutlined className="mr-1" />
                          <h1
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="text-[14px] text-[white]"
                          >
                            Add Menu
                          </h1>
                        </div>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-2 pl-4 pb-4 bg-[#ffffff]"
                  : "pr-1 pl-4 pb-4 bg-[#ffffff]"
              }
            >
              <div style={{ height: 400 }}>
                <SortableTree
                  treeData={treeData}
                  canDrag={true}
                  className="tree-bg font-label"
                  canDrop={true}
                  // style={{
                  //   innerHeight: '100px',
                  // }}
                  // innerStyle={'inner-style'}
                  rowHeight={72}
                  style={{
                    outerWidth: "700px",
                  }}
                  onChange={(data) => setTreeData(data)}
                />
              </div>
            </Col>
            <Drawer
              closable={false} // hide default X icon
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                    {editModal === true ? "Update Menu" : "Add Menu"}
                  </h1>
                  <Button
                    type="text"
                    onClick={onClose}
                    className="font-label"
                    icon={<CloseOutlined />}
                  />
                </div>
              }
              placement="right"
              onClose={onClose}
              open={open}
              width={450}
              maskClosable={false}
              className="font-label"
              styles={{
                body: {
                  padding: "18px",
                },
                footer: {
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 1,
                },
              }}
              footer={
                <div style={{ textAlign: "right", padding: "4px" }}>
                  <Space>
                    <Button
                      onClick={onClose}
                      style={{
                        background: "#fff1f0",
                        color: "#ff4d4f",
                        borderColor: "#ffa39e",
                      }}
                      className="font-label"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="font-label"
                      type="primary"
                      onClick={
                        editModal === true ? updateMenuDetails : addMenuDetails
                      }
                    >
                      {editModal === true ? "Submit" : "Update"}
                    </Button>
                  </Space>
                </div>
              }
            >
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <Typography className="font-label mb-1 text-[13px]">
                    Menu Type <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Select
                    value={menuType}
                    onChange={(newValue, options) =>
                      setMenuType({ label: options.label, value: newValue })
                    }
                    placeholder="Select Menu Type"
                    // mode="multiple"
                    options={[
                      {
                        label: "Menu Header",
                        value: "Menu Header",
                      },
                      {
                        label: "Menu Sub Header",
                        value: "Menu Sub Header",
                      },
                      // {
                      //   label: "Menu Sub Header",
                      //   value: "Menu Sub Header",
                      // },
                    ]}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={
                      media == "sm"
                        ? "w-[350px] font-label h-[40px] mt-2"
                        : media == "xs"
                        ? "w-[230px] font-label h-[40px] mt-2"
                        : "w-[100%] font-label h-[40px]"
                    }
                    rootClassName="purchase-label"
                  />
                  <span
                    style={{
                      color: "#ef3022",
                      fontSize: "11px",
                    }}
                  >
                    {simpleValidator.current.message(
                      "Menu Type",
                      menuType,
                      "required"
                    )}
                  </span>
                </Col>
                {menuType && menuType.value === "Menu Sub Header" ? (
                  <Col span={24}>
                    <Typography className="font-label mb-1 text-[13px]">
                      Sub Header Menu
                    </Typography>
                    <Select
                      value={subHeader}
                      onChange={(newValue, options) =>
                        setSubHeader({
                          label: options.label,
                          value: newValue,
                        })
                      }
                      placeholder="Select Sub Header"
                      // mode="multiple"
                      options={
                        menuHeader.length > 0
                          ? menuHeader.map((data) => {
                              return {
                                label: data.menuName,
                                value: data._id,
                              };
                            })
                          : []
                      }
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      className={
                        media == "sm"
                          ? "w-[350px] font-label h-[40px] mt-2"
                          : media == "xs"
                          ? "w-[230px] font-label h-[40px] mt-2"
                          : "w-[100%] font-label h-[40px]"
                      }
                      rootClassName="purchase-label"
                    />
                  </Col>
                ) : (
                  ""
                )}

                <Col span={24}>
                  <Typography className="font-label mb-1 text-[13px]">
                    Menu Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Input
                    className="font-label h-[40px]"
                    placeholder="Enter Menu Name"
                    value={menuName}
                    onChange={(e) => setMenuName(e.target.value)}
                  />
                  <span
                    style={{
                      color: "#ef3022",
                      fontSize: "11px",
                    }}
                  >
                    {simpleValidator.current.message(
                      "menuName",
                      menuName,
                      "required"
                    )}
                  </span>
                </Col>

                <Col span={24}>
                  <Typography className="font-label mb-1 text-[13px]">
                    Menu Key <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Input
                    className="font-label h-[40px]"
                    placeholder="Enter Menu Key"
                    value={menuKey}
                    onChange={(e) => setMenuKey(e.target.value)}
                  />
                  <span
                    style={{
                      color: "#ef3022",
                      fontSize: "11px",
                    }}
                  >
                    {simpleValidator.current.message(
                      "menuKey",
                      menuKey,
                      "required"
                    )}
                  </span>
                </Col>

                <Col span={24}>
                  <Typography className="font-label mb-1 text-[13px]">
                    Menu Access <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Select
                    value={menuAccess}
                    onChange={(values) => setMenuAccess(values)}
                    labelInValue
                    placeholder="Select Menu Access"
                    mode="multiple"
                    maxTagTextLength={11}
                    maxTagCount={"responsive"}
                    options={accessOptions}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={
                      media == "sm"
                        ? "w-[350px] font-label h-[40px] mt-2"
                        : media == "xs"
                        ? "w-[230px] font-label h-[40px] mt-2"
                        : "w-[100%] font-label h-[40px]"
                    }
                    rootClassName="purchase-label"
                  />
                  <span
                    style={{
                      color: "#ef3022",
                      fontSize: "11px",
                    }}
                  >
                    {simpleValidator.current.message(
                      "menuAccess",
                      menuAccess,
                      "required"
                    )}
                  </span>
                </Col>

                <Col span={24}>
                  <Typography className="font-label mb-1 text-[13px]">
                    Menu Mode
                  </Typography>
                  <Select
                    value={menuMode}
                    onChange={(newValue, options) =>
                      setMenuMode({ label: options.label, value: newValue })
                    }
                    placeholder="Select Menu Mode"
                    // mode="multiple"
                    options={[
                      {
                        value: "Menu",
                        label: "Menu",
                      },
                      {
                        value: "Page",
                        label: "Page",
                      },
                    ]}
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    className={
                      media == "sm"
                        ? "w-[350px] font-label h-[40px] mt-2"
                        : media == "xs"
                        ? "w-[230px] font-label h-[40px] mt-2"
                        : "w-[100%] font-label h-[40px]"
                    }
                    rootClassName="purchase-label"
                  />
                  <span
                    style={{
                      color: "#ef3022",
                      fontSize: "11px",
                    }}
                  >
                    {simpleValidator.current.message(
                      "menuMode",
                      menuMode,
                      "required"
                    )}
                  </span>
                </Col>
                <Col md={12} xl={10} xxl={10} lg={10} sm={24} xs={24}>
                  <Checkbox
                    checked={isNew}
                    className="font-label text-[13px]"
                    onChange={(e) => setIsNew(e.target.checked)}
                  >
                    Is New
                  </Checkbox>
                </Col>

                {isNew && (
                  <Col md={12} xl={14} xxl={14} lg={14} sm={24} xs={24}>
                    <Input
                      className="font-label text-[13px]"
                      placeholder="New Label"
                      value={newLabel}
                      onChange={(e) => setNewLabel(e.target.value)}
                    />
                  </Col>
                )}
              </Row>
            </Drawer>
          </Row>
          <Modal
            open={confirmationModal}
            onOk={() => {
              removeMenuDetails();
            }}
            closeIcon
            maskClosable={false}
            okText={"Confirm"}
            cancelText={"Cancel"}
            okType="danger"
            okButtonProps={{
              disabled: removeBtnDisabled ? true : false,
            }}
            onCancel={() => setConfirmationModal(false)}
            height={300}
            footer={(_, { OkBtn, CancelBtn }) => (
              <div className="text-center flex justify-center">
                <CancelBtn />
                <div className="ml-3">
                  <OkBtn />
                </div>
              </div>
            )}
          >
            <div className="text-center w-[100%] p-7">
              <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
              <h1 className="font-label text-center text-[16px] font-bold">
                Are you sure you want to Delete the Menu?
              </h1>
            </div>
          </Modal>
          {/* <Modal
            title={modalTitle}
            open={isModalOpen}
            closeIcon
            // okText={"Save"}
            maskClosable={false}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            centered
            // footer={(_, { OkBtn, CancelBtn }) => (
            //   <>
            //     <CancelBtn />
            //     <OkBtn />
            //   </>
            // )}
            width={800}
            style={{
              padding: 0,
              marginLeft: windowDimensions.width > 992 ? "220px" : "0",
            }}
          > */}
          <Modal
            title={modalTitle}
            open={isModalOpen}
            closeIcon
            maskClosable={false}
            onCancel={() => {
              setIsModalOpen(false);
              resetFields();
              setIsEditMode(false);
            }}
            centered
            footer={null}
            width={800}
            style={{
              padding: 0,
              marginLeft: windowDimensions.width > 992 ? "220px" : "0",
            }}
          >
            <Divider
              style={{ width: "110%", marginTop: "3px", marginLeft: "-24px" }}
            />
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <div className="flex items-center mb-1">
                  <Typography className="font-label text-[13px]">
                    Label
                  </Typography>
                  <span className="text-red-500 ml-1">*</span>
                </div>
                <Input
                  value={label}
                  onChange={(e) => setLabel(e.target.value)}
                  placeholder="Enter Label"
                  className="w-full h-[40px] font-poppins"
                />
                <span
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                  }}
                >
                  {menuValidator.current.message("label", label, "required")}
                </span>
              </Col>

              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <div className="flex items-center mb-1">
                  <Typography className="font-label text-[13px]">
                    Color
                  </Typography>
                  <span className="text-red-500 ml-1">*</span>
                </div>
                <Input
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                  placeholder="Enter Color"
                  className="w-full h-[40px] font-poppins"
                />
                <span
                  style={{
                    color: "#ef3022",
                    fontSize: "11px",
                  }}
                >
                  {menuValidator.current.message("color", color, "required")}
                </span>
              </Col>

              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <Typography className="font-label text-[13px] mb-1">
                  Icon (24X24 pixel)
                </Typography>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row", // Change from column to row
                    alignItems: "center", // Vertically center items
                    gap: "12px", // Gap between button and preview
                  }}
                >
                  <Upload
                    accept="image/*"
                    beforeUpload={handleUpload}
                    showUploadList={false}
                    maxCount={1}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ padding: "20px" }}
                    >
                      {iconPreview ? "Change Icon" : "Upload Icon"}
                    </Button>
                  </Upload>

                  {iconPreview && (
                    <div
                      style={{
                        position: "relative",
                        width: "24px",
                        height: "24px",
                      }}
                    >
                      <Image
                        src={iconPreview}
                        width={24}
                        height={24}
                        preview={false}
                        style={{
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                        }}
                      />
                      <CloseOutlined
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#d9d9d9",
                          color: "white",
                          borderRadius: "50%",
                          padding: "2px",
                          fontSize: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIconPreview(null);
                         // setIconFile(null);
                        }}
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Col md={24} lg={24} sm={24} xs={24}>
                <div className="flex items-center mt-2">
                  <Switch
                    checked={isEnable}
                    checkedChildren="ON"
                    unCheckedChildren="OFF"
                    onChange={(checked) => {
                      setIsEnable(checked); // Update state when switched
                      console.log("Switch toggled:", checked); // Optional logging
                    }}
                    className="custom-inner-switch"
                  />
                  {/* <span className="ml-2 text-sm font-medium text-gray-700">
                    {isEnable ? "Enabled" : "Disabled"}
                  </span> */}
                </div>
              </Col>
              <Col md={24} lg={24} sm={24} xs={24}>
                <Row justify="end" style={{ marginTop: "5px" }}>
                  <Button
                    type="primary"
                    className="font-label"
                    style={{
                      width: "110px",
                      height: "35px",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                    disabled={disabled}
                    // disabled={disabled || !isEnable}
                    onClick={handleSubmit}
                    loading={buttonLoader}
                  >
                    {isEditMode ? "Update" : "Submit"}
                  </Button>
                </Row>
              </Col>

              {!isEmpty(tableData) && (
                <Col
                  span={24}
                  className={
                    media === "xxl"
                      ? "pt-8 pl-4 pb-12 pr-4"
                      : media === "md"
                      ? "mt-[-10px] pl-4 pb-12 pr-4"
                      : "pt-1 pl-4 pb-12 pr-4"
                  }
                >
                  <Table
                    style={{
                      overflow: "hidden",
                    }}
                    bordered
                    columns={columns}
                    className="custom-header-table"
                    rowClassName={"p-0"}
                    expandable={{
                      defaultExpandAllRows: false,
                    }}
                    sortDirections={"ascend"}
                    loading={tableLoading}
                    showSorterTooltip={"sorter-icon"}
                    scroll={{
                      y: "100%",
                      x: "max-content",
                    }}
                    dataSource={tableData}
                    pagination={false}
                  />
                </Col>
              )}
            </Row>

            {/* <Divider
              style={{
                marginTop: "3px",
                marginBottom: "-2px",
                width: "110%",
                marginLeft: "-24px",
              }}
            /> */}

            <Modal
              open={deleteConfirmationModal}
              onOk={() => {
                handleDelete();
              }}
              closeIcon
              maskClosable={false}
              okText={"Confirm"}
              cancelText={"Cancel"}
              okType="danger"
              onCancel={() => setDeleteConfirmationModal(false)}
              height={300}
              footer={(_, { OkBtn, CancelBtn }) => (
                <div className="text-center flex justify-center">
                  <CancelBtn />
                  <div className="ml-3">
                    <OkBtn />
                  </div>
                </div>
              )}
            >
              <div className="text-center w-[100%] p-7">
                <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
                <h1 className="font-label text-center text-[16px] font-bold">
                  Are you sure you want to Delete this record?
                </h1>
              </div>
            </Modal>
          </Modal>
        </Col>
      </Row>
    </React.Fragment>
  );
};

MenuDetails.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default MenuDetails;
